import React from 'react';

import { IconButton } from 'components';
import Modal from 'components/Modal';
import { ButtonV3 } from 'components/ComponentV2';
import { useSponsorCompanies } from 'lib/providers/SocietySponsorshipProvider';

import styles from './RemoveSponsorModal.module.scss';

interface RemoveSponsorModalProps {
  open: boolean;
  isInConversation: boolean;
  companyId: string;
  onClose: () => void;
}

export const RemoveSponsorModal: React.FC<RemoveSponsorModalProps> = (
  props: RemoveSponsorModalProps
) => {
  const { open, isInConversation, companyId, onClose } = props;
  const { isLoading, removeSponsor } = useSponsorCompanies();

  const onRemove = async () => {
    const response = await removeSponsor(companyId, isInConversation);
    if (response) {
      onClose();
    }
  };

  return (
    <Modal
      isOpen={open}
      onRequestClose={onClose}
      contentClassName={styles.RemoveSponsorModal}
    >
      <div className={styles.RemoveSponsorModalHeader}>
        <p className={styles.title}>Remove sponsor</p>
        <IconButton
          className={styles.closeIcon}
          iconName="close"
          size="small"
          onClick={() => onClose()}
        />
      </div>
      <div className={styles.RemoveSponsorModalContent}>
        <p>Are you sure you want to remove sponsor?</p>
        <p>Removing sponsor will remove all their related Huzzle features.</p>
      </div>
      <div className={styles.RemoveSponsorModalAction}>
        <ButtonV3 color="black" variant="text" onClick={() => onClose()}>
          Cancel
        </ButtonV3>
        <ButtonV3 color="danger" isLoading={isLoading} onClick={onRemove}>
          Yes, Remove
        </ButtonV3>
      </div>
    </Modal>
  );
};
